import {ReactComponent as ExchangeIcon} from './exchange.svg'
function Exchange() {
  return <ExchangeIcon />
}
export default Exchange
